import {
  MdOutlineAddCard,
  MdOutlineCreditCardOff,
  MdOutlineTimelapse,
  MdPercent,
} from 'react-icons/md';
import { PerformanceReportResume } from 'types';
import { BigNumberCard, CARD_STATUS } from 'components';
import { formatMillisecondsToHours } from 'helpers';
import * as S from './styles';

interface SelectedPeriodResumeProps {
  performanceResume: PerformanceReportResume;
}

export function SelectedPeriodResume({
  performanceResume,
}: SelectedPeriodResumeProps) {
  const {
    confirmedPercentage,
    confirmedQuantity,
    revokedQuantity,
    timeActionAverage,
  } = performanceResume;

  const { hours, minutes, seconds } =
    formatMillisecondsToHours(timeActionAverage);
  const avgTimeFormatted = `${hours}:${minutes}:${seconds}`;

  return (
    <S.Wrapper>
      <BigNumberCard
        icon={<MdOutlineAddCard />}
        title="Pedidos aceitos"
        tooltipText="Pedidos aceitos por sua loja"
        status={CARD_STATUS.POSITIVE}
      >
        {confirmedQuantity}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdOutlineCreditCardOff />}
        title="Pedidos recusados"
        tooltipText="Pedidos recusados por sua loja"
        status={CARD_STATUS.NEGATIVE}
      >
        {revokedQuantity}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdOutlineTimelapse />}
        title="Tempo de ação"
        tooltipText="Tempo médio para iniciar o atendimento dos pedidos"
        status={CARD_STATUS.POSITIVE}
      >
        {avgTimeFormatted}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdPercent />}
        title="Porcentagem de aceite"
        tooltipText="Porcentagem de pedidos atendidos"
        status={CARD_STATUS.POSITIVE}
      >
        {confirmedPercentage}%
      </BigNumberCard>
    </S.Wrapper>
  );
}
